export default __webpack_public_path__ + "media/images/celeste_rotate-2abb395c58c12ed5c7196ee9420de5ef.png";